module.exports = __webpack_public_path__ + "img/progress5.1ee4ad36.png";